import { InputControl } from '@/components/controls/input-control';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../hooks';
import { MoniLogo } from '@/common/icons/MoniLogo';

export const SectionAuth = () => {
  const { t, form, onSubmit, isLoading } = useAuth();
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="w-[400px]">
        <div className="bg-bg-default relative flex h-full w-full flex-col items-center justify-center gap-6 rounded-lg p-9 pb-6">
          <div className="flex w-full flex-col gap-3">
            <MoniLogo className="h-8 w-10" />
            <div className="flex flex-col gap-1">
              <h2 className="text-md font-semibold text-white">
                {t('enter_cotton_system')}
              </h2>
              <p className="text-sm font-normal text-white/50">
                {t('enter_system')}
              </p>
            </div>
          </div>
          <div className="flex w-full flex-col gap-5">
            <InputControl
              inputClassName="h-[36px] rounded-[8px] border-white/15 bg-white/06 text-white/50"
              control={form.control}
              name="username"
              labelClass="text-white"
              label={'Login'}
              required
            />
            <InputControl
              inputClassName="h-[36px] rounded-[8px] border-white/15 bg-white/06 text-white/50"
              type="password"
              control={form.control}
              name="password"
              labelClass="text-white"
              label={'Parol'}
              required
            />
          </div>
          <Button
            type="submit"
            className="relative my-6 h-[40px] w-full overflow-hidden rounded-[6px] bg-[#2B5DF3] text-sm text-white hover:bg-blue-500"
          >
            <div className="absolute top-[-80%] h-[39px] w-full bg-white opacity-[80%] blur-[40px]" />
            {isLoading && <Loader2 className="animate-spin" />}
            Kirish
          </Button>
        </div>
      </form>
    </Form>
  );
};
